import { getPods } from "services/onboardingServices";
import { validateEmail } from "services/utilityService";
import { validateGitHubToken } from "services/validateGitToken";
import { EMAIL_VALIDATION_FAILED, POD_VALIDATION_FAILED } from "utility/constants";
import { PodItem } from "utility/types";

export const initiateGithubTokenValidation = async (patToken: string, teamName: string, githubUserId: string) => {
    try {
      const result = await validateGitHubToken(
        patToken,
        teamName,
        githubUserId
      );
      let tokenError = "";
      if (!result.tokenvalidity) {
        tokenError = "Invalid Token";
      } else if (!result.userIdValid) {
        tokenError = "Invalid User ID based on token";
      } else if (!result.orgAccess) {
        tokenError = "Add organization access to your token";
      } else if (!result.teamAccess) {
        tokenError = "No access to the specified team";
      }
      if (tokenError) {
        return tokenError;
      }
      return;
    } catch (error) {
      console.log("Error");
      return "Token validation failed.";
    }
  }
  
export const validateEmailCustomYupValidation = async (value?: string) => {
    try {
        if (!(value && value.length > 0)) { return true; }
        const response = await validateEmail(value);
        return response && response.result === "success";
    } catch(error) {
        console.log("error", error)
        throw new Error(EMAIL_VALIDATION_FAILED)
    }
}

export const validatePodCustomYupValidation = async (value: string) => {
  try {
      if (!(value && value.length > 0)) return true
      const podList = await getPods();
      if(!podList || !podList?.result) return false;
      return !podList.result.some((podItem: PodItem) => podItem.u_primary.toLowerCase() === value.toLowerCase())
  } catch(error) {
      console.log("error", error)
      throw new Error(POD_VALIDATION_FAILED)
  }
}


export const emailDomainRegex = /^[A-Za-z0-9._%+-]+@toyota\.com$/

export const s3URIRegex = /^s3:\/\/[a-z0-9.-]{3,63}\/.+$/

export const isRoleAdmin = (accessToken: string) => {
  if(!accessToken) { return false; }
  try {
    const { roles }: { roles: undefined | string[] } = JSON.parse(atob(accessToken.split('.')[1])) || {}
    return (roles && roles?.some((role) => role.toLowerCase().includes("admin")))
  } catch {
    return false;
  }
}

export const isArrayOfStringsOrNumbers = (data: unknown): data is (string | number)[] => {
  return Array.isArray(data) && data.every(item => typeof item === 'string' || typeof item === 'number');
};
